module.exports = __webpack_public_path__ + "828124a495d5aea3aae9995ec2cab232.svg";